import { c as _c } from "react/compiler-runtime";
import { Grid } from "@mui-wrapper";
import CheckRectangular from "@assets/illustrations/check_rectangular_l18.svg?react";
import TabsIntegrations from "@assets/illustrations/tabs_integration.svg?react";
import { INTEGRATION_INFO } from "@src/constants/integrations-constants";
import { Dialog, Divider, FontWeights, SvgIcon, Text } from "@flat-ui";

/** Shows dialog for successfully connecting to an integration */
export function IntegrationsSuccessfulDialog(t0) {
  const $ = _c(17);
  const {
    dialogConfirmCallback,
    integrationId
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      paddingX: "28px",
      maxWidth: "100%",
      alignItems: "center",
      flexDirection: "column"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Text variant="heading32" sx={{
      fontWeight: FontWeights.Regular
    }}>Integration connected</Text>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      marginBottom: "40px"
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const t4 = `Enable ${INTEGRATION_INFO[integrationId].displayName} in your project whenever you want`;
  let t5;
  if ($[3] !== t4) {
    t5 = <Text variant="bodyM" sx={t3}>{t4}</Text>;
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <SvgIcon source={CheckRectangular} sx={{
      width: "95px",
      height: "95px"
    }} />;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Divider sx={{
      marginY: "40px",
      width: "100%"
    }} />;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      marginTop: "0px",
      marginBottom: "40px",
      textAlign: "center"
    };
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  const t9 = `To use ${INTEGRATION_INFO[integrationId].displayName}, you need to enable it in a
            Sphere XG project. To do this, go to the "Integrations" tab on the project details page.`;
  let t10;
  if ($[8] !== t9) {
    t10 = <Text variant="bodyM" sx={t8}>{t9}</Text>;
    $[8] = t9;
    $[9] = t10;
  } else {
    t10 = $[9];
  }
  let t11;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <SvgIcon source={TabsIntegrations} sx={{
      width: "450px",
      height: "72px"
    }} />;
    $[10] = t11;
  } else {
    t11 = $[10];
  }
  let t12;
  if ($[11] !== t10 || $[12] !== t5) {
    t12 = <Grid container={true} sx={t1}>{t2}{t5}{t6}{t7}{t10}{t11}</Grid>;
    $[11] = t10;
    $[12] = t5;
    $[13] = t12;
  } else {
    t12 = $[13];
  }
  let t13;
  if ($[14] !== dialogConfirmCallback || $[15] !== t12) {
    t13 = <Dialog open={true} onConfirm={dialogConfirmCallback} confirmText="Got it" title="">{t12}</Dialog>;
    $[14] = dialogConfirmCallback;
    $[15] = t12;
    $[16] = t13;
  } else {
    t13 = $[16];
  }
  return t13;
}